import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  /**
   * Almacenar datos en local storage
   * @param key <string>
   * @param data <any>
   */
  saveData(key: string, data: any): void {
    try {
      if (data === null || data === undefined) {
        localStorage.removeItem(key);
        return;
      }
      localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      console.error(`Error saving data to localStorage for key ${key}:`, error);
    }
  }

  /**
   * Obtener datos del local storage
   * @param key <string>
   * @returns <any> Los datos parseados o null si no existen o hay error
   */
  getData(key: string): any {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error(
        `Error getting data from localStorage for key ${key}:`,
        error,
      );
      return null;
    }
  }

  /**
   * Verificar si existe una clave en localStorage
   * @param key <string>
   * @returns <boolean>
   */
  hasKey(key: string): boolean {
    try {
      return localStorage.getItem(key) !== null;
    } catch (error) {
      console.error(
        `Error checking key existence in localStorage for key ${key}:`,
        error,
      );
      return false;
    }
  }

  /**
   * Remover un elemento específico del localStorage
   * @param key <string>
   */
  removeData(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(
        `Error removing data from localStorage for key ${key}:`,
        error,
      );
    }
  }

  /**
   * Limpiar todo el localStorage
   */
  clearAll(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }

  /**
   * Obtener todas las claves del localStorage
   * @returns <string[]>
   */
  getAllKeys(): string[] {
    try {
      const keys: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key) {
          keys.push(key);
        }
      }
      return keys;
    } catch (error) {
      console.error('Error getting all keys from localStorage:', error);
      return [];
    }
  }

  /**
   * Obtener el tamaño aproximado del localStorage en bytes
   * @returns <number>
   */
  getStorageSize(): number {
    try {
      let totalSize = 0;
      for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key)) {
          totalSize += localStorage[key].length + key.length;
        }
      }
      return totalSize;
    } catch (error) {
      console.error('Error calculating localStorage size:', error);
      return 0;
    }
  }
}
